// Lightweight Input component - replaces NextUI Input
import React from 'react';

const Input = ({ 
  placeholder, 
  value, 
  onChange, 
  onKeyDown,
  className = '',
  startContent,
  endContent,
  variant = 'bordered',
  size = 'md',
  type = 'text',
  ...props 
}) => {
  const baseClasses = "w-full px-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#DC2626] focus:border-transparent transition-all duration-200 bg-white";
  
  const sizeClasses = {
    sm: "text-sm py-1.5",
    md: "text-base py-2",
    lg: "text-lg py-2.5"
  };

  const variantClasses = {
    bordered: "border-gray-300",
    flat: "border-transparent bg-gray-100",
    underlined: "border-b-2 border-gray-300 rounded-none"
  };

  return (
    <div className={`relative ${className}`}>
      {startContent && (
        <div className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 z-10">
          {startContent}
        </div>
      )}
      <input
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onKeyDown={onKeyDown}
        className={`${baseClasses} ${sizeClasses[size]} ${variantClasses[variant]} ${startContent ? 'pl-10' : ''} ${endContent ? 'pr-10' : ''}`}
        {...props}
      />
      {endContent && (
        <div className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 z-10">
          {endContent}
        </div>
      )}
    </div>
  );
};

export default Input;
